/**
 * 
 * @param {number} percent
 * @param {number} decimalPlaces that the result should be accurate to
 * 
 * @returns {number}
 */
function roundDownPaymentPercentage(percent, decimalPlaces = 1) {
    const roundingEpsilon = 10 ** (decimalPlaces+1); // round to 1 more decimal place than needed
    const roundedPercent = Math.round(percent * roundingEpsilon) / roundingEpsilon; // float math is inaccurate so make the significant digits integers to round.
    const resultEpsilon = 10 ** decimalPlaces; // how accurate our result needs to be

    return Math.round(roundedPercent * resultEpsilon) / resultEpsilon;
}

export default roundDownPaymentPercentage;